<template>
  <div class="d-flex flex-column bg-white w-100 align-items-center p-2 rounded mt-2" style="border: 1px solid #222">
    <h3 style="font-size: 1.1vw !important">{{ name }}</h3>
    <div v-if="insert" class="d-flex flex-row align-items-baseline bg-secondary rounded mb-2 p-2 justify-content-center" style="width: 70vw;">
      <div class="d-flex flex-column">
        <label>{{ label_one }}</label>
        <input v-model="key" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column mx-2">
        <label>{{ label_two }} </label>
        <input v-model="value" type="text" class="form-control">
      </div>
      <button @click.prevent="store" v-if="!is_edit" class="btn btn-primary btn-submit-1" style="transform: translateY(1.5vw)">ذخیره</button>
      <button @click.prevent="update" v-if="is_edit" class="btn btn-primary btn-submit-1 mx-2" style="transform: translateY(1.5vw)">ویرایش
      </button>
      <Reset @click.prevent="reset"
             style="width: 1.5vw; height: 1.5vw; transform: translateY(1.9vw); cursor: pointer; margin-right: 1vw;"/>

    </div>
    <hr>
    <div v-if="items.length" class="table-responsive">
      <div class="mt-2" style="overflow-y: scroll; height: 12vw;">
        <table class="table table-striped mt-3" style="width: 70vw; ">
          <thead>
          <tr class="sticky-header">
            <th>ردیف</th>
            <th> {{ label_one }}</th>
            <th> {{ label_two }}</th>
            <th v-if="insert" style="width: 6vw;">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in items">
            <td style="width: 1vw;">{{ index+1 }}</td>
            <td>{{item.key}}</td>
            <td>{{item.value}}</td>
            <td v-if="insert">
              <div class="d-flex justify-content-evenly">
                <a @click.prevent="edit(item)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg"
                                                             alt="edit"></a>
                <a @click.prevent="deleteItem(item.id)" href="#"><img class="table-delete-img"
                                                                      src="/img/delete.f9fc94bc.svg"
                                                                      alt="delete"></a>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <center v-else class="alert alert-info" style="width: 70vw;">
      <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
        <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
        </symbol>
        <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
          <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
        </symbol>
        <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </symbol>
      </svg>
      <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Info:"><use xlink:href="#info-fill"/></svg>

      {{name}} یافت نشد
    </center>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 55%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemMethod">تایید</button>
      </div>
    </div>
  </div>
</template>

<script>
import Reset from "@/components/Icons/Reset.vue";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  components: {Reset},
  props: {
    insert: {
      type: Boolean,
      required: true
    },  name: {
      type: String,
      required: true
    },
    label_one: {
      type: String,
      required: true
    },
    label_two: {
      type: String,
      required: true
    },
    type: {
      type: Number,
      required: true
    }, id: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      deleteModal: false,
      is_edit: false,
      key: '',
      value: '',
      id_item: null,
      items: [],
    }
  },
  methods: {
    store() {
      if (!this.key){
        toast.error(`${this.label_one} اجباری است. `)
        return
      }else  if (!this.value){
        toast.error(`${this.label_two} اجباری است. `)
        return
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('p_id', this.id)
      formdata.append('type', this.type)
      formdata.append('key', this.key)
      formdata.append('value', this.value)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }if (response.message) {
              toast.success(response.message)
              this.reset()
              this.all()
            }



          })
          .catch();
    },
    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      // Construct the query parameters
      const url = new URL(`${this.base_url}/impact-assessment/all`);
      url.searchParams.append('type', this.type);
      url.searchParams.append('id', this.id);

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(url, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error);
              return;
            }
            this.items.length = 0;
            response.all.forEach((item) => {
              this.items.push(item);
            });
          })
          .catch(error => console.error('Error:', error));
    },

    edit(item) {
      this.is_edit = true
      this.id_item = item.id
      this.key = item.key
      this.value = item.value

    }, reset() {
      this.is_edit = false
      this.key = ''
      this.value = ''
      this.deleteModal = false

    },
    deleteItem(id) {
      this.id_item = id
      this.deleteModal = true
    },
    update(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('p_id', this.id)
      formdata.append('type', this.type)
      formdata.append('key', this.key)
      formdata.append('value', this.value)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/update/${this.id_item}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }if (response.message) {
              toast.success(response.message)
              this.reset()
              this.all()
            }



          })
          .catch();
    },
    deleteItemMethod(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/impact-assessment/delete/${this.id_item}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }if (response.message) {
              toast.success(response.message)
              this.reset()
              this.all()
            }



          })
          .catch();
    },
  },
  mounted() {
    this.all()
  }
};
</script>
